module.exports = __webpack_public_path__ + "33ec9b900f0b36e49b96e6a15c7068ca.svg";